// Codes visuels partagés entre AccreditationConfigApp et AccreditationPublicFormPage — dérivés
// du design importé (claude.ai/design, projet "Redesign de page" : Formulaires Accreditation.dc.html
// / Formulaire Accreditation Public.dc.html). Couleurs normalisées sur les tokens officiels du
// design system Wilout (node_modules/@wilout/ui-css/dist/ui.css --ui-color-teal-*) plutôt que les
// valeurs de la maquette au pixel près (ex. #00B797 → #00be9e, teal-300 exact) — cohérence avec le
// reste de l'app plutôt que fidélité stricte à la maquette.
import { HeartHandshake, Newspaper, Star, Wrench, Users } from 'lucide-react';

// Devine une icône/couleur "catégorie" à partir du libellé du formulaire (ex. "Bénévoles" →
// vert). Purement décoratif : aucune donnée métier n'en dépend, juste un repère visuel rapide
// dans la liste — un libellé qui ne matche rien retombe sur l'icône neutre par défaut.
const CATEGORIES = [
  { test: /b[eé]n[eé]vole/i, icon: HeartHandshake, bg: '#e6f6ee', fg: '#007739' },
  { test: /presse|m[eé]dia/i, icon: Newspaper, bg: '#e7f0fb', fg: '#005ea1' },
  { test: /vip|partenaire/i, icon: Star, bg: '#fdf1d6', fg: '#946200' },
  { test: /staff|technique|exposant/i, icon: Wrench, bg: '#f3e8fb', fg: '#7a2fb0' },
];
const DEFAULT_CATEGORY = { icon: Users, bg: '#eefaf6', fg: '#007773' };

export const categoryVisual = (label) => CATEGORIES.find((c) => c.test.test(label || '')) || DEFAULT_CATEGORY;

export const STATUS_META = {
  pending: { label: 'En attente', bg: '#fff9de', fg: '#b67600' },
  approved: { label: 'Validée', bg: '#d0f4e3', fg: '#007739' },
  rejected: { label: 'Refusée', bg: '#ffedea', fg: '#970000' },
};

// Dégradé de marque (teal-300 → teal-400 → teal-700, tokens officiels) utilisé sur les bandeaux
// d'en-tête et le bouton principal, comme dans la maquette.
export const BRAND_GRADIENT = 'linear-gradient(to right, #00be9e, #007773, #002f36)';
